import { AssetDto, AssetImageTypeDataDto } from '@nusign/picflow-backend-types';
import { getCaptureTime } from '../../lib/extract-exif';
import { textCollator } from '../../lib/text-collator';

const sortAlphaNum = (a, b) => a.localeCompare(b, 'en');

export const sortAssetSection = (assets: AssetDto[], sortBy = 'position'): AssetDto[] => {
  if (!sortBy) sortBy = 'position';

  const inverted = sortBy.startsWith('-');
  if (inverted) sortBy = sortBy.slice(1);

  let sortedAssets = assets.slice();
  sortedAssets.sort((a, b) => sortAlphaNum(a.id, b.id)); // sort by id to keep order of equal values

  if (sortBy === 'created_at') {
    sortedAssets.sort((a, b) => a.created_at - b.created_at);
  }
  if (sortBy === 'name') {
    sortedAssets.sort((a, b) => textCollator.compare(a.name, b.name));
  }

  if (sortBy === 'position') sortedAssets.sort((a, b) => a.position - b.position);
  if (sortBy === 'likes') sortedAssets.sort((a, b) => a.likes - b.likes);

  if (sortBy === 'capture_time') {
    const captureTimes = new Map();
    assets.forEach(asset => {
      const data = <AssetImageTypeDataDto>asset.version_data?.data;
      captureTimes.set(asset.id, getCaptureTime(data?.exif));
    });
    sortedAssets = [
      ...sortedAssets
        .filter(a => captureTimes.has(a.id))
        .sort((a, b) => captureTimes.get(a.id) - captureTimes.get(b.id)),
      ...sortedAssets.filter(a => !captureTimes.has(a.id)),
    ];
  }

  if (inverted) sortedAssets.reverse();
  return sortedAssets;
};

export const sortRelevantFieldChanged = (sortBy: string, oldAsset: AssetDto, newAsset: AssetDto): boolean => {
  const inverted = sortBy.startsWith('-');
  if (inverted) sortBy = sortBy.slice(1);

  if (sortBy === 'name') {
    return oldAsset.name !== newAsset.name;
  }
  if (sortBy === 'position') {
    return oldAsset.position !== newAsset.position;
  }
  return false;
};
